/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var GetAvailableTasks = require('../services/GetAvailableTasks');

var PageableCollection = require('psa-backbone/models/PageableCollection');

var GridView = require('psa-marionette/views/GridView');

module.exports = {
  channel: 'nd:internal-dashboard',

  event: 'build:available-tasks-grid-view',

  builder: function(gridColumns) {
    var deferred = $.Deferred();
    GetAvailableTasks()
      .done(function(availableTasks) {
        deferred.resolve(
          new GridView({
            columns: gridColumns,
            collection: new PageableCollection(availableTasks, { pageSize: 10 }),
            emptyText: 'No Tasks Available.'
          })
        );
      })
      .fail(function(err) {
        deferred.reject(err);
      });

    return deferred.promise();
  }
};
